import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CartService } from '../cart.service';
import { MetaDataService } from '../metadata.service';
import { NGXLogger } from 'ngx-logger';
import { environment } from '../../environments/environment';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'tea-shop-fe-checkout-status',
    templateUrl: './checkout-status.component.html',
    styleUrl: './checkout-status.component.css',
    imports: [NgTemplateOutlet, RouterLink]
})
export class CheckoutStatusComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private cartService = inject(CartService);
  private router = inject(Router);
  private metaDataService = inject(MetaDataService);
  private logger = inject(NGXLogger);


  customerEmail: string | null = 'your email address';
  sessionId!: string;
  orderId!: string;

  isLoading = true;
  errors: string[] = [];

  constructor() { 
    this.metaDataService.updateMetadata({
      title: 'Checkout Status',
      image: '/assets/contact/sencha-logo.png',
    });
  }

  ngOnInit() {
    // Get the sessionId paremeter from the URL
    this.route.params.subscribe(params => {
      this.sessionId = params['sessionId'];
      this.cartService.retrieveCheckoutSession(this.sessionId).subscribe({
        next: (session) => {
          if (session.status === 'open') {
            this.router.navigate(['/checkout']);
            return;
          }
          this.isLoading = false;
          this.logger.log('CheckoutStatusComponent checkout', session);
          this.customerEmail = session.customer_email || session.customer_details.email;
          this.orderId = session.orderId;
          const clearCart = environment.production || confirm('Would you like to clear your cart? ');
          this.logger.log('clearCart', clearCart);
          if (clearCart) {
            this.cartService.clearCart();
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.errors.push('An error occurred while retrieving the checkout session. Please try again shortly.');
          // this.errors.push(error.message);
          this.logger.error('An error occurred while retrieving the checkout session:', error);
        }
      });
    });
    this.logger.log('CheckoutStatusComponent ngOnInit');
  }

}
